webpackJsonp([114276838955818,60335399758886],{

/***/ 166:
/***/ (function(module, exports) {

	module.exports = {"data":{"mainMenu":{"name":"Main Menu","items":[{"title":"Home","url":"https://admin.czonemusic.com/","items":null},{"title":"Services","url":"https://admin.czonemusic.com/services/","items":[{"title":"Disc Jockeys","url":"https://admin.czonemusic.com/services/dj-services/"},{"title":"Jazz &#038; Contemporary Groups","url":"https://admin.czonemusic.com/services/jazz-and-contemporary-groups/"},{"title":"String & Brass Ensembles","url":"https://admin.czonemusic.com/services/string-and-brass-ensembles/"},{"title":"Uplighting","url":"https://admin.czonemusic.com/services/wireless-led-uplighting/"},{"title":"Photo Booths","url":"https://admin.czonemusic.com/services/photo-booths/"},{"title":"DJ &#038; Percussion Fusion","url":"https://admin.czonemusic.com/services/percussion-and-dj-combo/"},{"title":"DJ &#038; Sax Fusion","url":"https://admin.czonemusic.com/services/dj-sax-fusion/"},{"title":"Photography Services","url":"https://admin.czonemusic.com/services/photography-services/"}]},{"title":"Event Planning Tools","url":"https://admin.czonemusic.com/event-planning-tools/","items":null},{"title":"DJ &#038; Musician Profiles","url":"https://admin.czonemusic.com/dj-and-musician-profiles/","items":null},{"title":"Testimonials","url":"https://admin.czonemusic.com/testimonials/","items":null},{"title":"Friends","url":"https://admin.czonemusic.com/friends/","items":null},{"title":"Contact","url":"https://admin.czonemusic.com/contact/","items":null},{"title":"Social","url":"https://admin.czonemusic.com/social/","items":null}]},"footer1":{"name":"Footer 1","items":[{"title":"Disc Jockeys","url":"https://admin.czonemusic.com/services/dj-services/","items":null},{"title":"Jazz &#038; Contemporary Groups","url":"https://admin.czonemusic.com/services/jazz-and-contemporary-groups/","items":null},{"title":"String & Brass Ensembles","url":"https://admin.czonemusic.com/services/string-and-brass-ensembles/","items":null},{"title":"Uplighting","url":"https://admin.czonemusic.com/services/wireless-led-uplighting/","items":null},{"title":"Photo Booths","url":"https://admin.czonemusic.com/services/photo-booths/","items":null},{"title":"DJ &#038; Percussion Fusion","url":"https://admin.czonemusic.com/services/percussion-and-dj-combo/","items":null},{"title":"DJ &#038; Sax Fusion","url":"https://admin.czonemusic.com/services/dj-sax-fusion/","items":null},{"title":"Photography Services","url":"https://admin.czonemusic.com/services/photography-services/","items":null}]},"footer2":{"name":"Footer 2","items":[{"title":"Home","url":"https://admin.czonemusic.com/","items":null},{"title":"Event Planning Tools","url":"https://admin.czonemusic.com/event-planning-tools/","items":null},{"title":"DJ &#038; Musician Profiles","url":"https://admin.czonemusic.com/dj-and-musician-profiles/","items":null},{"title":"Testimonials","url":"https://admin.czonemusic.com/testimonials/","items":null},{"title":"Friends","url":"https://admin.czonemusic.com/friends/","items":null},{"title":"Contact","url":"https://admin.czonemusic.com/contact/","items":null}]},"footer3":{"name":"Footer 3","items":[{"title":"Facebook","url":"http://facebook.com/czonemusic","items":null},{"title":"Twitter","url":"http://twitter.com/czonemusic","items":null},{"title":"Instagram","url":"http://instagram.com/czonemusic","items":null},{"title":"YouTube","url":"http://youtube.com/djczone1","items":null}]}},"layoutContext":{}}

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(350);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(166);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _footerMenu = __webpack_require__(345);
	
	var _footerMenu2 = _interopRequireDefault(_footerMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
		var footer1 = _ref.footer1,
		    footer2 = _ref.footer2,
		    footer3 = _ref.footer3;
	
		return _react2.default.createElement(
			'footer',
			{ className: 'bg-black' },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-lg-offset-3 col-md-offset-3 col-lg-2 col-md-2 col-sm-4 col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'widget widget_nav_menu' },
							_react2.default.createElement(
								'h3',
								null,
								'SERVICES'
							),
							_react2.default.createElement(_footerMenu2.default, {
								items: footer1.items
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-lg-2 col-md-2 col-sm-4 col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'widget widget_nav_menu' },
							_react2.default.createElement(
								'h3',
								null,
								'NAVIGATION'
							),
							_react2.default.createElement(_footerMenu2.default, {
								items: footer2.items
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-lg-2 col-md-2 col-sm-4 col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'widget widget_nav_menu' },
							_react2.default.createElement(
								'h3',
								null,
								'SOCIAL'
							),
							_react2.default.createElement(_footerMenu2.default, {
								items: footer3.items
							})
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row copyright' },
					_react2.default.createElement(
						'div',
						{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'widget' },
							'\xA9 2003-2015 C-Zone Entertainment. All Rights Reserved. | 617.320.0723 | contact@czonemusic.com'
						)
					)
				)
			)
		);
	};
	
	Footer.propTypes = {
		footer1: _propTypes2.default.object,
		footer2: _propTypes2.default.object,
		footer3: _propTypes2.default.object
	};
	
	Footer.defaultProps = {
		footer1: {},
		footer2: {},
		footer3: {}
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(112);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _wordpressHelpers = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterMenu = function FooterMenu(_ref) {
		var items = _ref.items;
	
		return _react2.default.createElement(
			'ul',
			null,
			items && items.map(function (item) {
				return _react2.default.createElement(
					'li',
					{ key: item.url },
					(0, _wordpressHelpers.isExternalLink)(item.url) ? _react2.default.createElement(
						'a',
						{ href: item.url },
						item.title
					) : _react2.default.createElement(_gatsbyLink2.default, {
						dangerouslySetInnerHTML: (0, _wordpressHelpers.innerHtml)(item.title) // eslint-diable-line react/no-danger
						, to: (0, _wordpressHelpers.replaceLinks)(item.url)
					})
				);
			})
		);
	};
	
	FooterMenu.propTypes = {
		items: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	FooterMenu.defaultProps = {
		items: []
	};
	
	exports.default = FooterMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(112);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(813);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _wordpressHelpers = __webpack_require__(41);
	
	var _componentHelpers = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = (_temp = _class = function (_Component) {
		_inherits(Header, _Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.state = {
				menuActive: false
			};
	
			_this.menu = null;
			_this.toggle = null;
			_this.handleToggle = _this.handleToggle.bind(_this);
			_this.checkClick = _this.checkClick.bind(_this);
			return _this;
		}
	
		Header.prototype.componentDidMount = function componentDidMount() {
			document.addEventListener('click', this.checkClick);
		};
	
		Header.prototype.componentWillUnmount = function componentWillUnmount() {
			document.removeEventListener('click', this.checkClick);
		};
	
		Header.prototype.checkClick = function checkClick(e) {
			if (this.menu && this.menu.contains(e.target) || this.toggle && this.toggle.contains(e.target)) {
				return;
			}
	
			this.setState({ menuActive: false });
		};
	
		Header.prototype.handleToggle = function handleToggle(menuActive) {
			this.setState({ menuActive: menuActive });
		};
	
		Header.prototype.render = function render() {
			var _this2 = this;
	
			var menu = this.props.menu;
			var menuActive = this.state.menuActive;
	
	
			var navClasses = ['collapse', 'navbar-collapse'];
	
			if (menuActive) {
				navClasses.push('in');
			}
	
			return _react2.default.createElement(
				'header',
				{ className: 'banner navbar navbar-default navbar-static-top', role: 'banner' },
				_react2.default.createElement(
					'div',
					{ className: 'container-fluid' },
					_react2.default.createElement(
						'div',
						{ className: 'navbar-header' },
						_react2.default.createElement(
							'button',
							{ ref: _componentHelpers.ref.call(this, 'toggle'), onClick: (0, _componentHelpers.clickPrevent)(this.handleToggle, !menuActive), type: 'button', className: 'navbar-toggle collapsed' },
							_react2.default.createElement(
								'span',
								{ className: 'sr-only' },
								'Toggle Navigation'
							),
							_react2.default.createElement('span', { className: 'icon-bar' }),
							_react2.default.createElement('span', { className: 'icon-bar' }),
							_react2.default.createElement('span', { className: 'icon-bar' })
						),
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ className: 'navbar-brand', to: '/', onClick: (0, _componentHelpers.click)(this.handleToggle, false) },
							_react2.default.createElement('img', { src: _logo2.default })
						)
					),
					_react2.default.createElement(
						'nav',
						{ ref: _componentHelpers.ref.call(this, 'menu'), className: navClasses.join(' '), role: 'navigation' },
						_react2.default.createElement(
							'div',
							{ className: 'menu-main-menu-container' },
							_react2.default.createElement(
								'ul',
								{ id: 'menu-main-menu', className: 'nav navbar-nav navbar-right' },
								menu.items && menu.items.map(function (item) {
									var itemClass = ['menu-item'];
									var hasDropdown = item.items && item.items.length > 0;
	
									if (hasDropdown) {
										itemClass.push('menu-item-has-children');
										itemClass.push('dropdown');
									}
	
									return _react2.default.createElement(
										'li',
										{ key: item.url, className: itemClass.join(' ') },
										_react2.default.createElement(_gatsbyLink2.default, {
											dangerouslySetInnerHTML: { __html: item.title } // eslint-disable-line react/no-danger
											, to: (0, _wordpressHelpers.replaceLinks)(item.url),
											onClick: (0, _componentHelpers.click)(_this2.handleToggle, false)
										}),
										hasDropdown ? _react2.default.createElement(
											'ul',
											{ role: 'menu', className: 'dropdown-menu' },
											item.items.map(function (child) {
												return _react2.default.createElement(
													'li',
													{ key: child.url },
													_react2.default.createElement(_gatsbyLink2.default, {
														dangerouslySetInnerHTML: { __html: child.title } // eslint-disable-line react/no-danger
														, to: (0, _wordpressHelpers.replaceLinks)(child.url),
														onClick: (0, _componentHelpers.click)(_this2.handleToggle, false)
													})
												);
											})
										) : null
									);
								})
							)
						)
					)
				)
			);
		};
	
		return Header;
	}(_react.Component), _class.propTypes = {
		menu: _propTypes2.default.object
	}, _class.defaultProps = {
		menu: {
			items: []
		}
	}, _temp);
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.07a58f43.png";

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mainMenuQuery = exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(35);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	__webpack_require__(689);
	
	var _header = __webpack_require__(347);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(344);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = (_temp = _class = function (_Component) {
		_inherits(DefaultLayout, _Component);
	
		function DefaultLayout() {
			_classCallCheck(this, DefaultLayout);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		DefaultLayout.prototype.render = function render() {
			var _props$data = this.props.data,
			    footer1 = _props$data.footer1,
			    footer2 = _props$data.footer2,
			    footer3 = _props$data.footer3;
	
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_header2.default, {
					menu: this.props.data.mainMenu
				}),
				_react2.default.createElement(
					'div',
					{ className: 'wrap', role: 'document' },
					_react2.default.createElement(
						'div',
						{ className: 'content' },
						_react2.default.createElement(
							'main',
							{ className: 'main' },
							this.props.children()
						)
					)
				),
				_react2.default.createElement(_footer2.default, {
					footer1: footer1,
					footer2: footer2,
					footer3: footer3
				})
			);
		};
	
		return DefaultLayout;
	}(_react.Component), _class.propTypes = {
		children: _propTypes2.default.func.isRequired,
		location: _propTypes2.default.object.isRequired,
		data: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = DefaultLayout;
	var mainMenuQuery = exports.mainMenuQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6faa470674e11981425b.js